module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hans_4-ae377963d60cfd3e5f9adedeb4d8bfda.jpg";